import { faEnvelope, faGlobe, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import useHome from '../../context/useHome'

const Scope4 = () => {
    const { homeData } = useHome()

    return (
        <>
            {homeData && homeData.jobReqContact &&
                <div className='home-scope4 flex justify-center items-center p-3'>
                    <div className="div-content margin-auto">
                        <div className="title text-center">ติดต่อ</div>
                        <div className="orgName text-center">{homeData.jobReqContact.orgUnitName}</div>
                        <div className="orgNameEn text-center w-full break-words">{homeData.jobReqContact.orgUnitNameEn}</div>
                        <div className="div-address mt-4">
                            <div className="address text-address flex">
                                <FontAwesomeIcon icon={faLocationDot} className='fa-location' />
                                <div className='txt-address'>{homeData.jobReqContact.address}</div>
                            </div>
                            <div className="address-2 text-address">
                                {homeData.jobReqContact.district}&nbsp;{homeData.jobReqContact.subDistrict}&nbsp;
                                {homeData.jobReqContact.province}&nbsp;{homeData.jobReqContact.postCode}
                            </div>
                        </div>
                        <div className="div-email mt-4 ">
                            <a href={`mailto:${homeData.jobReqContact.email}`} className='text-address flex'>
                                <FontAwesomeIcon icon={faEnvelope} className='fa-envolope' />
                                <div className='txt-address'>{homeData.jobReqContact.email}</div>
                            </a>
                        </div>
                        <div className="div-website mt-4 ">
                            <a href={homeData.jobReqContact.website} className='text-address flex' target="_blank" rel="noreferrer">
                                <FontAwesomeIcon icon={faGlobe} className='fa-glope' />
                                <div className='txt-address'>{homeData.jobReqContact.website}</div>
                            </a>
                        </div>
                        <div className="div-phone mt-4 text-address">
                            <FontAwesomeIcon icon={faPhone} className='fa-phone' />
                            {homeData.jobReqContact.telephone}
                        </div>
                    </div>
                </div>
            }
        </>

    )
}

export default Scope4